import { openMeldRuntimeProfileIdSchema } from "../protocol/profile.js";
import { spaceRouteParamsSchema } from "./space-route-params.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-board.ts
const isoDateTimeSchema = z$1.iso.datetime({ offset: true });
const trimmedNonEmptyStringSchema = z$1.string().trim().min(1);
const nullableTrimmedNonEmptyStringSchema = trimmedNonEmptyStringSchema.nullable();
const spaceBoardOutcomeSchema = z$1.enum([
	"replied",
	"failed",
	"stopped",
	"timed_out"
]);
const spaceBoardSpaceSchema = z$1.strictObject({
	id: trimmedNonEmptyStringSchema,
	name: trimmedNonEmptyStringSchema,
	purpose: nullableTrimmedNonEmptyStringSchema,
	guide: nullableTrimmedNonEmptyStringSchema
});
const spaceBoardMembersSchema = z$1.strictObject({
	totalCount: z$1.number().int().min(0),
	humanCount: z$1.number().int().min(0),
	agentCount: z$1.number().int().min(0),
	centerAgentPresent: z$1.boolean()
});
const spaceBoardAgentProfileSchema = z$1.strictObject({
	profileId: openMeldRuntimeProfileIdSchema,
	profileName: nullableTrimmedNonEmptyStringSchema
});
const spaceBoardRoomProjectionSchema = z$1.strictObject({
	space: spaceBoardSpaceSchema,
	members: spaceBoardMembersSchema,
	agentProfiles: z$1.array(spaceBoardAgentProfileSchema)
});
const spaceBoardWorkingExecutionSchema = spaceBoardAgentProfileSchema.extend({ startedAt: isoDateTimeSchema });
const spaceBoardRecentOutcomeSchema = spaceBoardAgentProfileSchema.extend({
	at: isoDateTimeSchema,
	outcome: spaceBoardOutcomeSchema
});
const getSpaceBoardInputSchema = spaceRouteParamsSchema;
const spaceBoardResponseSchema = z$1.strictObject({
	space: spaceBoardSpaceSchema,
	members: spaceBoardMembersSchema,
	workingNow: z$1.array(spaceBoardWorkingExecutionSchema),
	recentOutcomes: z$1.array(spaceBoardRecentOutcomeSchema).max(10)
});
//#endregion
export { getSpaceBoardInputSchema, spaceBoardAgentProfileSchema, spaceBoardMembersSchema, spaceBoardOutcomeSchema, spaceBoardRecentOutcomeSchema, spaceBoardResponseSchema, spaceBoardRoomProjectionSchema, spaceBoardSpaceSchema, spaceBoardWorkingExecutionSchema };

//# sourceMappingURL=space-board.js.map